<template>
  <v-chip class="chip-style" @click="ctaClick" large>
    <div class="d-flex align-center justify-center mx-3" style="width: 100% !important;">
      <h5 class="powered-by-text">{{ $t('poweredBy') }}</h5>
      <v-img :src="imageUrl" class="ml-1" max-width="70" position="left center" contain/>
    </div>
  </v-chip>
</template>

<script>
export default {
  name: "PoweredBy",
  data() {
    return {
      imageUrl: 'https://hub.swiset.com/wp-content/uploads/2018/07/Swiset_Logo_RGB_Black-Medium.png', 
      ctaUrl: 'https://swiset.com',
    };
  },
  methods: {
    ctaClick() {
      window.open(this.ctaUrl);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/global";

.powered-by-text {
  font: bold 16px $title-font !important;
  color: var(--v-mainBlack-base) !important;
}

.chip-style {
  border: 1px solid $border-color !important;
  border-radius: 28px;
  background-color: transparent !important;
  padding: 15px;
}

.chip-style:hover {
  color: #247851;
  border: 2px solid #247851 !important;
  background-color: transparent !important;
}

</style>

